import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // New messages for OTP fallback functionality
  authenticateAnotherWayButton: {
    description: 'Button text for switching between phone MFA and TOTP authentication methods',
    defaultMessage: 'Authenticate Another Way',
    id: 'ZPpeR2',
  },

  totpFallbackModalTitle: {
    description: 'Modal title when TOTP is offered as fallback in unskippable state',
    defaultMessage: 'Secure Your Account with an Authenticator App',
    id: 'RqoRKL',
  },

  securitySubHeader: {
    description: 'title for a page that allows users to adjust their account security',
    defaultMessage: 'Security',
    id: 'PiYiZ3',
  },
  multiFactorAuthenticationTitle: {
    description: 'title for a section where users control their multi-factor authentication methods',
    defaultMessage: 'Multi-Factor Authentication',
    id: '7jKpvE',
  },
  multiFactorAuthenticationText: {
    description: 'explainer text detailing the important of multi-factor authentication and offering a few options',
    defaultMessage:
      'Add another layer of security to your account with multi-factor authentication (MFA). You can opt to receive verification codes via email, text message, or via authenticator app.',
    id: 'KLB9A8',
  },
  manageSettingsButton: {
    description: 'text for a button that allows users to manage their account security settings',
    defaultMessage: 'Manage settings',
    id: 'Fx/u+8',
  },
  timeoutErrorMessage: {
    description: "text for an error banner that indicates the user's session has expired and they must reauthorize",
    defaultMessage:
      'Your multi-factor authenticator settings session has expired. Please reverify your account to continue editing these settings.',
    id: 'W+/2U4',
  },
  stepUpAuthModalTitle: {
    description: 'title of a section that allows user to adjust their multi-factor authentication settings',
    defaultMessage: 'Multi-Factor Authentication Settings',
    id: 'Pt+23t',
  },
  accountSecurity: {
    description: 'title for a page that allows users to adjust their account security',
    defaultMessage: 'Account Security',
    id: 'YK/fyz',
  },
  tableHeader: {
    description: 'title for a table that lists the current multi-factor enrollments',
    defaultMessage: 'Current MFA Enrollments',
    id: 'OKaJiU',
  },
  columnType: {
    description: 'type',
    defaultMessage: 'Type',
    id: 'muZyGk',
  },
  columnDescription: {
    description: 'description',
    defaultMessage: 'Description',
    id: 'ZRrCqt',
  },
  columnEnrolledFactors: {
    description: 'title for a list that contains the details of a multi-factor enrollment',
    defaultMessage: 'Details',
    id: 's4Zuyy',
  },
  columnCreateDate: {
    description: 'title for a list that contains all the multi-factor enrollments the user has set up',
    defaultMessage: 'Created on',
    id: 'XbiE5g',
  },
  columnLastAuthDate: {
    description: 'header for a column that indicates when a multi-factor authentication method was "last used" to log into the app',
    defaultMessage: 'Last used',
    id: 'uZmaH5',
  },
  columnActionButton: {
    description: 'title for a column that contains a single "action" users can take on the data in the table',
    defaultMessage: 'Action',
    id: 'Rf46/B',
  },
  phoneName: {
    description: 'method of identity check where the user will receive an sms/text message',
    defaultMessage: 'Phone',
    id: 'BgGmyZ',
  },
  emailName: {
    description: 'email',
    defaultMessage: 'Email',
    id: 'tCwlQg',
  },
  totpName: {
    description: 'method of identity check where the user relies on an authenticator app to provide a time-based one-time password',
    defaultMessage: 'TOTP',
    id: 'qFLLvM',
  },
  authenticatorAppName: {
    description:
      'alt name for a method of identity check where the user relies on an authenticator app to provide a time-based one-time password',
    defaultMessage: 'Authenticator App',
    id: 'f71X+K',
  },
  buttonAddMfaEnrollment: {
    description: 'add new option',
    defaultMessage: 'Add new option',
    id: 'rj7mdS',
  },
  buttonDelete: {
    description: 'delete',
    defaultMessage: 'Delete',
    id: 'qpFbwr',
  },
  cancelButton: {
    description: 'text for a button that will cancel the current workflow when clicked',
    defaultMessage: 'Cancel',
    id: 'sHkunm',
  },
  continueButton: {
    description: 'text for a button that will continue the current workflow when clicked',
    defaultMessage: 'Continue',
    id: '5igs9M',
  },
  sendCodeButton: {
    description: 'text for a button that will send the user a verification code when clicked',
    defaultMessage: 'Send code',
    id: 'Bgfj0r',
  },
  buttonVerifyCode: {
    description: 'text for a button that will allow users to verify the received code',
    defaultMessage: 'Verify code',
    id: 'KFPQ3R',
  },
  defaultError: {
    description: 'generic error message',
    defaultMessage: 'An error occurred.',
    id: 'RaG8LO',
  },
  deleteEnrollmentModalHeader: {
    description: 'header for a modal that confirms users intend to delete an existing authentication method',
    defaultMessage: 'Delete Authentication Method Confirmation',
    id: 'Ne1UcC',
  },
  deleteEnrollmentModalH3: {
    description: 'hero text for a modal that confirms users intend to delete an existing authentication method',
    defaultMessage: 'Are you sure you want to delete this authentication method?',
    id: 'aTZNOA',
  },
  deleteEnrollmentModalParagraph: {
    description: 'additional text for a modal that confirms users intend to delete an existing authentication method',
    defaultMessage: 'If you want to use this method again in the future, you will need to add it as a new method.',
    id: 'ed9FLg',
  },
  selectEnrollmentTypeHeader: {
    description: 'header for a modal that allows users to add a new verification method to their account',
    defaultMessage: 'Add a New Verification Method',
    id: 'HgLuU1',
  },
  selectEnrollmentTypeSubheader: {
    description: 'explainer text for a modal that allows users to add a new verification method to their account',
    defaultMessage: 'Select the type of verification you want to add to your account.',
    id: 'CbDPig',
  },
  verificationMethods: {
    description: 'label for a list that contains the various verification methods a user can choose from',
    defaultMessage: 'Verification methods',
    id: 'J7k2KS',
  },
  addEnrollmentModalHeader: {
    description: 'title for a modal that will allow a user to enroll a multi-factor authentication factor',
    defaultMessage: 'Multi-Factor Authentication Enrollment',
    id: 'FGj99I',
  },
  secureAccountModalHeader: {
    description: 'title for forced MFA flow modal that emphasizes account security',
    defaultMessage: 'Secure Your Account',
    id: 'bUY/bG',
  },
  emailEnrollmentFormTitle: {
    description: 'title for a form where users add an email address as a verification method',
    defaultMessage: 'Add Email Verification',
    id: 'spk+mR',
  },
  emailEnrollmentFormText: {
    description: 'helper text explaning how a user can enroll an email address for multi-factor authentication',
    defaultMessage: 'Enter the email address you want to use for the Email verification method.',
    id: 'y3lH2a',
  },
  emailEnrollmentInputLabel: {
    description: 'label for an email input',
    defaultMessage: 'Email',
    id: 'aNSAzV',
  },
  phoneEnrollmentFormTitle: {
    description: 'title for a form where users add a phone as a verification method',
    defaultMessage: 'Add Phone Verification',
    id: '/QSq9B',
  },
  phoneEnrollmentFormTitleForced: {
    description: 'title for forced MFA flow phone form emphasizing phone number entry',
    defaultMessage: 'Enter Phone Number',
    id: 'E1HgM7',
  },
  phoneEnrollmentFormText: {
    description: 'helper text explaning how a user can enroll a phone for multi-factor authentication',
    defaultMessage: 'Enter the mobile number you want to use for the Voice or SMS verification methods.',
    id: 'yKZvCR',
  },
  phoneEnrollmentFormTextForced: {
    description: 'helper text for forced MFA flow explaining password recovery benefit',
    defaultMessage: 'To enable easy access to your account if you forget your password, verify your phone number.',
    id: 'xAXWRY',
  },
  phoneEnrollmentInputLabel: {
    description: 'label for an input where users supply a mobile phone number',
    defaultMessage: 'Mobile number',
    id: 'CZjWp+',
  },
  phoneEnrollmentDeliveryMethodLabel: {
    description: 'label for an input where users select whether they want to receive a verification code via text or phone call',
    defaultMessage: 'How would you like to receive your code?',
    id: 'tuxWxI',
  },
  smsEnrollmentOption: {
    description: 'Text message',
    defaultMessage: 'Text message',
    id: 'epN8s4',
  },
  voiceEnrollmentOption: {
    description: 'Phone call',
    defaultMessage: 'Phone call',
    id: 'o+Vy9d',
  },
  authenticatorEnrollmentFormTitle: {
    description: 'title for a form where users add an authenticator app as a verification method',
    defaultMessage: 'Add Authenticator App Verification',
    id: 'WOFfsF',
  },
  authenticatorEnrollmentFormTitleForced: {
    description: 'title for forced MFA flow authenticator form',
    defaultMessage: 'Add Authenticator App Verification',
    id: 'K2VOQU',
  },
  authenticatorEnrollmentFormText: {
    description:
      'helper text explaning that a future feature will allow a user can use an authenticator app for multi-factor authentication',
    defaultMessage:
      'Use your preferred time-based one-time password (TOTP) generating application to enroll the secret key below (via QR code scanning) for the Authenticator App verification method.',
    id: 'pEQJDG',
  },
  authenticatorEnrollmentFormTextForced: {
    description: 'helper text for forced MFA flow explaining 2FA benefits',
    defaultMessage:
      'Add an extra layer of protection to your ShipStation account by enabling Two-Factor Authentication (2FA) using an authenticator app.',
    id: 'CEYvBI',
  },
  authenticatorSetupInstructions: {
    description: 'numbered list of setup instructions for authenticator app',
    defaultMessage:
      '1.) Open your preferred authenticator app (e.g., Google Authenticator, Authy, Microsoft Authenticator).\n2.) Scan the QR code below or enter the secret key manually.\n3.) Enter the 6-digit verification code from your app to complete setup.',
    id: 'R9HAWd',
  },
  authenticatorSecurityExplanation: {
    description: 'explanation of authenticator app security benefits',
    defaultMessage: 'This one-time setup links your authenticator app with ShipStation, keeping your account more secure.',
    id: 'PDXm7p',
  },
  authenticatorEnrollmentFormSecretLabel: {
    description: 'label for a secret key',
    defaultMessage: 'Secret key',
    id: '5tLKZW',
  },
  authenticatorCopyButtonTooltip: {
    description: 'copy this key',
    defaultMessage: 'Copy this key',
    id: 'omT0Lv',
  },
  defaultEnrollmentName: {
    description: 'copy this key',
    defaultMessage: '<i>Enrolled and active</i>',
    id: 'grdXw0',
  },
  mfaEnabledStatus: {
    description: 'Text indicating that MFA is enabled for this user',
    defaultMessage: 'Enabled',
    id: 'P2Vkbt',
  },
  phoneConsentCustomerServiceAndSupportCheckboxLabel: {
    description: 'Label for checkbox to consent to SMS customer service and support',
    defaultMessage: 'I would like the ability to text with customer service and support.',
    id: 'PJPK2p',
  },
  phoneConsentDisclaimer: {
    description: 'Disclaimer text for SMS consent checkbox explaining opt-in terms',
    defaultMessage:
      'By opting in, you are consenting to be contacted by SMS text message. Message and data rates may apply. You can reply STOP to opt-out of further messaging.',
    id: '1m+RR5',
  },
});
